import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { ShimmerSectionHeader } from "react-shimmer-effects";
import "./modal.css";
import CfdCardItem from "../../CfdCardItem";

const MakeOfferModal = ({
  item,
  onRefresh,
  activeTab,
  showPlaceOffer,
  makeOfferModalState,
  offerAmount,
  offerAmountError,
  buyersPremiumData,
  formatPrice,
  minBidAmount,
  handleInputChange,
  handleIncrement,
  handleDecrement,
  handleSubmitOffer,
  offerSubmissionState,
  resetMakeOfferModalState,
}) => {
  const listPrice =
    makeOfferModalState?.propertyData?.listingPriceDetail?.listPrice;
  const currentHighestBid =
    makeOfferModalState?.propertyData?.listingPriceDetail?.currentHighestBid;
  const bidIncrementalAmnt =
    makeOfferModalState?.propertyData?.listingPriceDetail
      ?.biddingIncrementalAmount;

  const formatToDollar = (price) => {
    if (!price && price !== 0) return "";
    if (isNaN(price)) return "";
    return `$${price.toLocaleString()}`;
  };

  return (
    <Modal
      centered
      className="cfd-disclaimer-modal"
      size={offerSubmissionState.status === "SUCCESS" ? "md" : "lg"}
      show={showPlaceOffer}
      backdrop="static"
      onHide={() => {
        resetMakeOfferModalState();
        onRefresh(activeTab);
      }}
    >
      <Modal.Header closeButton>
        {offerSubmissionState.status !== "SUCCESS" && (
          <Modal.Title className="cfd-modal-title">
            {currentHighestBid ? "Place New Offer" : "Make An Offer"}
          </Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body>
        {makeOfferModalState.isLoading ? (
          <div className="text-center">
            <ShimmerSectionHeader center />
          </div>
        ) : offerSubmissionState.status === "SUCCESS" ? (
          <div className="cfd-success-container">
            <div class="cfd-success-tick"></div>
            <div className="cfd-modal-successMsg">
              Your offer has been submitted!
            </div>

            <p className="modalFooterTest-s">
              {offerSubmissionState.successMessage}
            </p>
          </div>
        ) : offerSubmissionState.status === "ERROR" ? (
          <div className="text-center text-danger">
            <p>{offerSubmissionState.errorMessage}</p>
          </div>
        ) : (
          <div className="cfd-make-offer-modal">
            {makeOfferModalState.propertyData && (
              <CfdCardItem isModalOpen item={item} activeTab={activeTab} />
            )}
            {listPrice && (
              <div className="cfd-offer-info-modal">
                <p className="cfd-offer-label-modal">List Price:</p>
                <p className="cfd-offer-amount-modal">
                  {formatPrice(listPrice)}
                </p>
              </div>
            )}
            {currentHighestBid && (
              <div className="cfd-offer-info-modal">
                <p className="cfd-offer-label-modal">
                  Your Current Offer Amount:
                </p>
                <p className="cfd-offer-amount-modal">
                  {formatPrice(currentHighestBid)}
                </p>
              </div>
            )}
            <div className="cfd-offer-info-modal mb-5 mt-2">
              <p className="cfd-offer-label-modal">
                {currentHighestBid
                  ? "Your New Offer Amount:"
                  : "Your Offer Amount:"}
              </p>
              <div>
                <div className="cfd-offer-input-group">
                  <button
                    className="btn btn-outline-secondary cfd-no-border"
                    type="button"
                    style={{
                      fontFamily: "graphikregular",
                      fontWeight: 700,
                      color: "#000",
                      fontSize: 20,
                    }}
                    onClick={handleDecrement}
                    disabled={offerAmount <= minBidAmount}
                  >
                    -
                  </button>
                  <input
                    placeholder="$0"
                    className={`form-control text-center cfd-no-border ${
                      offerAmountError ? "is-invalid" : ""
                    }`}
                    value={formatToDollar(offerAmount)}
                    onChange={(e) => {
                      // Remove dollar sign and commas before parsing
                      const rawValue = e.target.value.replace(/[$,]/g, "");
                      const numValue =
                        rawValue === "" ? 0 : parseFloat(rawValue);
                      handleInputChange(numValue);
                    }}
                    min={buyersPremiumData.bidAmount}
                    step={bidIncrementalAmnt || 1}
                    style={{
                      fontFamily: "graphikmedium",
                    }}
                  />
                  <button
                    style={{
                      fontFamily: "graphikregular",
                      fontWeight: 700,
                      color: "#000",
                      fontSize: 20,
                    }}
                    className="btn btn-outline-secondary cfd-no-border"
                    type="button"
                    onClick={handleIncrement}
                  >
                    +
                  </button>
                </div>
                {offerAmountError && (
                  <div
                    className="invalid-feedback d-block"
                    style={{
                      color: "#cf3d3d",
                      marginTop: 2,
                      fontSize: 11,
                      fontFamily: "graphikregular",
                      textAlign: "center",
                    }}
                  >
                    {offerAmountError}
                  </div>
                )}
              </div>
            </div>
            <div className="cfd-offer-info-modal">
              <p
                className="cfd-offer-label-modal"
                style={{
                  textDecoration: "underLine dashed #000",
                  textUnderlineOffset: "5px",
                }}
              >
                Buyer's Premium:
              </p>

              <p
                className="cfd-offer-amount-modal"
                style={{
                  fontFamily: "graphikmedium",
                }}
              >
                {buyersPremiumData.buyerPremiumFormatted}
              </p>
            </div>
            <hr />
            <div className="cfd-offer-info-modal">
              <p
                className="cfd-offer-label-modal"
                style={{
                  textDecoration: "underLine dashed #000",
                  textUnderlineOffset: "5px",
                  fontFamily: "graphikmedium",
                }}
              >
                Total Purchase Price:
              </p>
              <p
                className="cfd-offer-amount-modal"
                style={{
                  fontFamily: "graphikmedium",
                }}
              >
                {buyersPremiumData.totalDueFormatted}
              </p>
            </div>
          </div>
        )}
      </Modal.Body>
      {offerSubmissionState.status !== "SUCCESS" && (
        <Modal.Footer className="d-flex justify-content-center align-items-center">
          {makeOfferModalState.isLoading || offerSubmissionState.loading ? (
            <Spinner animation="border" />
          ) : offerSubmissionState.status === "SUCCESS" ? (
            <button
              className="cfd-modal-btn"
              onClick={() => {
                resetMakeOfferModalState();
                onRefresh();
              }}
            >
              Close
            </button>
          ) : (
            <button
              className="cfd-modal-btn"
              onClick={handleSubmitOffer}
              style={{
                fontFamily: "graphiksemibold",
              }}
            >
              Submit Offer
            </button>
          )}
          <div>
            {!makeOfferModalState.isLoading && (
              <p className="cfdModalFooterText">
                By clicking on Submit, you accept the Hubzu{" "}
                <a href="/about/terms" target="_" className="cfd-target-link">
                  Terms & Conditions
                </a>{" "}
                and{" "}
                <a
                  href="https://www.altisource.com/Privacy-Policy"
                  target="_"
                  className="cfd-target-link"
                >
                  Privacy Policy
                </a>{" "}
                and agree to abide by the CFD Participation Agreement you’ve
                previously signed.
              </p>
            )}
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default MakeOfferModal;
